// extracted by mini-css-extract-plugin
module.exports = {"lang":"ku","langWrap":"kv","item":"kw","itemCurrent":"kx"};